import { Field, InputType } from '@warebee/shared/util-backend-only-types';
import { CreateBaseWarehouseEntityInput } from '../create-base-warehouse-entity.input';

@InputType()
export class CreateAssignmentInput extends CreateBaseWarehouseEntityInput {
  @Field()
  inputFileName?: string;
}
